export default "d7c339463fdeeeed.svg"